module.exports = __webpack_public_path__ + "img/pix.8bf8c309.svg";